import AuthToken from 'utils/localStorage/AuthToken';

const API_HOST = process.env.REACT_APP_API_HOST;

// Generic counterpart of fetchTicket: looks up a scanned instance by uuid in
// either the checkin namespace (event_uuid) or the org/event namespace, for a
// given resource path ("tickets" | "merch_collections").
const constructUrl = (params) => {
  const { event_uuid, event_id, organization_id, session_id, result, resourcePath } = params;

  const queryParams = new URLSearchParams();
  if (session_id) queryParams.append('session_id', session_id);

  let rootUrl;

  if (event_uuid) {
    queryParams.append('event_uuid', event_uuid);
    rootUrl = `checkin/${resourcePath}`;
  } else if (organization_id && event_id) {
    rootUrl = `organizations/${organization_id}/events/${event_id}/${resourcePath}`;
  }

  const queryString = queryParams.toString();
  return new URL(`${API_HOST}/${rootUrl}/${result}/${queryString ? `?${queryString}` : ''}`);
};

const constructInit = () => {
  const authToken = AuthToken.read();
  return {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    },
  };
};

export default async function fetchScannable(params) {
  const url = constructUrl(params);
  const init = constructInit();
  const response = await fetch(url, init);

  if (!response.ok) {
    if (response.status === 404) {
      throw `Item not found`;
    } else {
      throw `HTTP error! status: ${response.status}`;
    }
  }

  return response.json();
}
